import React, { useState } from "react";
import Draggable from "react-draggable";
import {
  Stack,
  Box,
  Button,
  TextField,
  Grid,
  Slider,
  Typography,
} from "@mui/material";
import { MdOutlineFileUpload } from "react-icons/md";
import { MdDownload } from "react-icons/md";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
//Srcs
import "./pagestyle.scss";

import CropImageFile from "../Components/CropImage/CropImageFile";
import FramImage from "../Assets/Facebook-Fram-2026-2027.png";

// import FramImage from "../Assets/Facebook-Fram-2024-2025.png";

import EmptyImage from "../Assets/empty-image.png";

export default function FrameImage() {
  // ========================= Upload Image =========================
  const [loading, setLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [checkDownLoad, setCheckDownLoad] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [infoMessage, setInfoMessage] = useState("");
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  const [position, setPosition] = useState({
    // x: 25,
    // y: 25,
    x: 0,
    y: 0,
  });

  const zoomStep = 0.1;
  const rotateStep = 5;

  const handleZoomIn = () => {
    setZoom((prev) => Math.min(prev + zoomStep, 3));
  };

  const handleZoomOut = () => {
    setZoom((prev) => Math.max(prev - zoomStep, 1));
  };

  const handleRotateLeft = () => {
    setRotation((prev) => (prev - rotateStep + 360) % 360);
  };

  const handleRotateRight = () => {
    setRotation((prev) => (prev + rotateStep) % 360);
  };

  const handleUploadImage = (e) => {
    setLoadingUpload(true);

    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);

      setImageFile(file);
      setPhotoURL(imageUrl);

      // reset position
      setPosition({
        x: 0,
        y: 0,
      });

      setZoom(1);
      setRotation(0);
    }

    setLoadingUpload(false);
  };

  // ======================== handleDownload image =========================
  const previewRef = React.useRef();

  // ======================== Handle Download =========================
  const handleDownloadImage = async () => {
    if (!previewRef.current) return;

    try {
      // const canvas = await html2canvas(previewRef.current, {
      //   scale: window.devicePixelRatio || 5,
      //   useCORS: true,
      //   backgroundColor: null,
      // });

      const canvas = await html2canvas(previewRef.current, {
        scale: 4, // High resolution
        useCORS: true,
        allowTaint: false,
        backgroundColor: null,
        imageTimeout: 15000,
        logging: false,
      });

      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

      // ===== iOS =====
      if (isIOS) {
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/png"),
        );

        if (!blob) {
          setInfoMessage("Unable to generate image.");
          return;
        }

        const file = new File([blob], "frame-profile.png", {
          type: "image/png",
        });

        // Use iOS Share Sheet (recommended)
        if (
          navigator.share &&
          navigator.canShare &&
          navigator.canShare({ files: [file] })
        ) {
          try {
            await navigator.share({
              files: [file],
              title: "Frame Profile",
              text: "Save Image to Photos",
            });

            return;
          } catch (err) {
            // User cancelled sharing
            if (err?.name === "AbortError") return;

            console.error(err);
          }
        }

        // Fallback for older iOS versions
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");

        setInfoMessage("Long press the image and choose 'Save to Photos'.");

        return;
      }

      // ===== Android + Desktop =====
      const dataUrl = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "frame-profile.png";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setInfoMessage("Image downloaded successfully.");
    } catch (error) {
      console.error(error);
      setInfoMessage("Unable to download image.");
    }
  };

  
  const handleCheckDownload = async () => {
    try {
      setLoading(true);
      await handleDownloadImage();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack direction="row" justifyContent="center" className="page-container">
      <Box>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12}>
            <Stack direction="column" spacing={2} justifyContent="center">
              <Box className="image-container" ref={previewRef}>
                {imageFile ? (
                  <>
                    <Stack direction="row" justifyContent="center">
                      <div className="avatar-wrapper">
                        <Draggable
                          position={position}
                          onDrag={(e, data) =>
                            setPosition({
                              x: data.x,
                              y: data.y,
                            })
                          }
                        >
                          <div
                            style={{
                              cursor: "grab",
                            }}
                          >
                            <img
                              alt=""
                              src={photoURL}
                              className="avatar-image"
                              draggable={false}
                              style={{
                                transform: `
                              scale(${zoom})
                              rotate(${rotation}deg)
                            `,
                                transformOrigin: "center center",
                              }}
                            />
                          </div>
                        </Draggable>
                      </div>
                    </Stack>

                    <img
                      alt=""
                      src={FramImage}
                      className="frame-image"
                      draggable={false}
                    />
                  </>
                ) : (
                  <>
                    <img
                      alt=""
                      src={EmptyImage}
                      className="avatar-image"
                      draggable={false}
                    />

                    <img
                      alt=""
                      src={FramImage}
                      className="frame-image"
                      draggable={false}
                    />
                  </>
                )}
              </Box>

              {/* ===========================
                    Controls
            ============================ */}

              <Stack direction="column" spacing={1} width="100%">
                <Typography className="lebel-header">
                  Upload, Adjust and Download
                </Typography>

                {/* Zoom */}

                <Box>
                  <Typography className="lebel-download">
                    Zoom: {zoomPercent(zoom)}
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Button variant="outlined" onClick={handleZoomOut}>
                      -
                    </Button>
                    <Slider
                      sx={{ flex: 1 }}
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      valueLabelDisplay="auto"
                      valueLabelFormat={zoomPercent}
                      onChange={(e, value) => setZoom(value)}
                    />

                    <Button variant="outlined" onClick={handleZoomIn}>
                      +
                    </Button>
                  </Stack>
                </Box>

                {/* Rotation */}

                <Box>
                  <Typography className="lebel-download">
                    Rotation: {rotation}°
                  </Typography>

                  <Stack direction="row" spacing={2} alignItems="center">
                    <Button variant="outlined" onClick={handleRotateLeft}>
                      ↺
                    </Button>

                    <Slider
                      sx={{ flex: 1 }}
                      value={rotation}
                      min={0}
                      max={360}
                      valueLabelDisplay="auto"
                      onChange={(e, value) => setRotation(value)}
                    />

                    <Button variant="outlined" onClick={handleRotateRight}>
                      ↻
                    </Button>
                  </Stack>
                </Box>

                {/* Buttons */}

                <Stack direction="row" spacing={2}>
                  {loadingUpload ? (
                    <Button
                      className="btn-download"
                      startIcon={<MdOutlineFileUpload />}
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button
                      component="label"
                      className="btn-download"
                      startIcon={<MdOutlineFileUpload />}
                    >
                      <TextField
                        type="file"
                        sx={{ display: "none" }}
                        onChange={handleUploadImage}
                      />
                      Upload File
                    </Button>
                  )}

                  {loading ? (
                    <Button
                      fullWidth
                      className="btn-download"
                      startIcon={<MdDownload />}
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button
                      fullWidth
                      className="btn-download"
                      startIcon={<MdDownload />}
                      onClick={handleCheckDownload}
                    >
                      Download
                    </Button>
                  )}
                </Stack>

                <Stack direction="row" justifyContent="center">
                  {infoMessage && (
                    <p
                      style={{
                        color: "black",
                        fontSize: 12,
                        textAlign: "center",
                      }}
                    >
                      {infoMessage}
                    </p>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}

const zoomPercent = (value) => {
  return `${Math.round(value * 100)}%`;
};
